<template>
  <div class="container">
    <div class="top-container">
      <div class="top-container-inner">
        <div id="top" class="step">
          <Step :currentStep="0" :steps="steps" />
        </div>
        <div class="title">
          <h1>申込内容を入力</h1>
        </div>
      </div>
    </div>
    <div class="l-container child-container">
      <div class="box">
        <div class="box-content">
          <SectionContentTitle
            :lineType="lineType.vertical"
            titleContent="お申し込み内容"
            class="mb-4 lg:mb-4"
          />
          <div>
            <Item :data="dataItemOrder" />
          </div>
          <div class="menu-content2">
            <div class="content">
              <table class="table-common">
                <tr class="label-inp">
                  <td class="flex style-l">
                    <div class="font-bold label-l">宿泊期間</div>
                  </td>
                  <td class="data">
                    <div class="items-data">
                      <div class="label-data">
                        <div class="info-live">
                          <span class="mr-2">{{
                            customerPlan ? customerPlan.stayDayJP : ''
                          }}</span>
                          <span class="mr-2"
                            >{{ customerPlan ? customerPlan.stayNights : '' }} 泊</span
                          >
                          <span class="mr-2"
                            >{{ customerPlan ? customerPlan.stayRooms : '' }} 部屋</span
                          >
                          <span class="mr-2"
                            >（大人{{ countAdultPeople | formatInteger }}名/子ども{{
                              totalChildren | formatInteger
                            }}名）</span
                          >
                        </div>
                        <div>
                          ※1回のご旅行でお申し込みいただける泊数は最大{{
                            customerPlan ? customerPlan.limitNights : 6
                          }}泊までとなります。<br />
                          ※宿泊日、部屋数を変更したい場合は、戻るボタンで前画面にて変更してください。<br />
                          ※既にご予約が成立している日程と同一日程の場合、他の施設で予約をすることはできません。異なるご利用者（ご家族）が同一日程の他施設を希望の場合は、家族アカウントをご登録のうえご予約をお願いいたします。
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr class="label-inp">
                  <td class="flex style-l">
                    <div class="font-bold label-l">チェックイン時間</div>
                    <div class="ml-4 category">必須</div>
                  </td>
                  <td class="data">
                    <div class="items-data">
                      <div class="content-data">
                        <div class="grid">
                          <a-select
                            class="select-items"
                            v-model="checkinTime"
                            :options="checkinTimeOptions"
                            @change="validateCheckInTime"
                          />
                          <span class="alert-message" ref="checkinTimeError">{{
                            checkInTimeErrorMsg
                          }}</span>
                          <span class="mt-2"
                            >※万が一遅れる場合は、施設へご連絡をお願いいたします。</span
                          >
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr class="label-inp" v-if="!isRakuten">
                  <td class="flex style-l">
                    <div class="font-bold label-l">交通手段</div>
                    <div class="ml-4 category">必須</div>
                  </td>
                  <td class="data">
                    <div class="items-data">
                      <div class="content-data">
                        <div class="grid relative">
                          <a-select
                            class="select-items"
                            v-model="moveDiv"
                            :options="vehicles"
                            @change="validateVehicle"
                          />
                          <span class="alert-message" ref="checkVehicleError">{{
                            checkVehicleErrorMsg
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr class="label-inp"></tr>
              </table>
              <div class="room-eyes">
                <!-- <div class="title-room">
                {{numberOfRooms}}部屋目
              </div> -->
                <div class="title-room">1部屋目</div>
                <!-- <div class="whitespace-pre-wrap mb-4" v-html="roomBasicInfoNote" /> -->
                <div>
                  ※会員ご本人及び配偶者の各2親等以内の方は「会員」欄にご利用人数を入力してください。（一部ご加入コースにより会員様の範囲が異なる場合もございます）<br />
                  ※1回のご旅行に際し、会員料金でのご利用は連続した日程で最長6泊まで、最大19名様までとなります。
                  7泊以上または20名様以上でお申込みの際は施設によってはビジター料金となる場合がございますのでご了承ください。<br />
                  ※利用者内訳に小学生・幼児の選択がない場合は、大人の人数に含めてください。<br />
                  ※幼児は0才児～未就学児までです。
                </div>
                <div class="room-table" ref="roomRef">
                  <div v-if="isRakutenPLan">
                    <PeopleOfRoomRakuten
                      v-model="tempStayRoomDetails[idx]"
                      v-for="(i, idx) in tempStayRoomDetails"
                      :roomErrors="roomErrors[idx].errors"
                      :deputationErrors="getDeputationErrors(idx)"
                      :numRoom="idx"
                      :vacancyCalendar="vacancyCalendar"
                      :key="`people-in-room-${idx}`"
                      :deputation="deputation"
                      :savedAdultTypeData="savedAdultTypeData[idx]"
                      :savedChildTypeData="savedChildTypeData[idx]"
                      :savedDeputyInfo="savedDeputyInfo[idx]"
                      @changePeopleCnt="onChangePeopleCnt"
                      @change="onChangeRoom"
                      @changeDeputation="onChangeDeputation"
                      @changeRepresentative="onChangeRepresentative"
                      @changeAdultTypeData="onChangeAdultTypeData"
                      @changeChildTypeData="onChangeChildTypeData"
                      @changePersonType="onchangePersonType"
                    />
                  </div>
                  <div v-else>
                    <PeopleOfRoomNew
                      v-model="tempStayRoomDetails[idx]"
                      v-for="(i, idx) in tempStayRoomDetails"
                      :roomErrors="roomErrors[idx].errors"
                      :numRoom="idx"
                      :vacancyCalendar="vacancyCalendar"
                      :key="`people-in-room-${idx}`"
                      :deputation="deputation"
                      @changePeopleCnt="onChangePeopleCnt"
                      @change="onChangeRoom"
                      @changeDeputation="onChangeDeputation"
                      @changeRepresentative="onChangeRepresentative"
                      @changeAdultTypeData="onChangeAdultTypeData"
                      @changeChildTypeData="onChangeChildTypeData"
                    />
                  </div>
                  <div
                    class="warning-box"
                    ref="warningMsg"
                    v-show="(bothRoomError && bothRoomError.length)"
                  >
                    <div
                      class="both-room-error-msg text-error text-right"
                      v-for="(error, idx) in bothRoomError"
                      :key="`both-room-error-msg-${idx}`"
                    >
                      {{ error }}
                    </div>
                  </div>
                  <!-- <span class="alert-message text-white" ref="checkRelationshipError">{{checkRelationshipErrorMsg}}</span> -->
                  <div class="room-btn-confirm flex justify-end mt-2">
                    <Button
                      class="btn-confirm"
                      v-if="subsidyList && subsidyList.length"
                      text="人数確定"
                      type="dark"
                      @click="confirmRoomPeople"
                      :disabled="!enableConfirmButton"
                    />
                  </div>
                  <div ref="errorSameValue">
                    <p class="alert-message same-value-error-message" v-if="errorSameValue">{{ errorSameValue }}</p>
                  </div>
                  <div class="total-value" ref="checkRelationshipError">
                    宿泊料合計 税込&emsp;<span>{{
                      calculateTotalAmount | formatCurrency
                    }}</span>
                  </div>
                  <div v-if="subsidyList && subsidyList.length" class="total-value">補助クーポンの適用前の金額となります。</div>
                  <div
                    class="mt-3 text-right"
                    v-if="grantedBenepo != null"
                  >
                    獲得予定ベネポ：{{ grantedBenepo | separatedByCommas }}P
                  </div>
                </div>
              </div>

              <div class="mb-8 mt-8 lg:mt-4" v-show="showRelationship">
                <a-divider class="custom-divider" />

                <SectionContentTitle
                  lineType="v-line"
                  titleContent="続柄選択"
                  class="mb-4 mt-8 lg:mt-12 lg:mb-4"
                />
                <PeopleRelationship
                  :stayRoomDetails="tempStayRoomDetails"
                  :visible="showRelationship"
                  :showRelationName="showRelationName"
                  @input="onRelationshipChange"
                  @adultCnt="getAdultCntMember($event)"
                  @messageErrorAge="getMessageErrorAge($event)"
                  @messageErrorSei="getMessageErrorSei($event)"
                  @messageErrorMei="getMessageErrorMei($event)"
                  :isReRenderListRoom="isReRenderListRoom"
                  :isRakutenPLan="isRakutenPLan"
                  :shouldUpdateRelationships="shouldUpdateRelationships"
                  :cacheRelationships="cacheRelationships"
                />
                <div class="font-bold text-primary">
                  {{ error_message_age_relationship }}
                </div>
                <div class="font-bold text-primary">
                  {{ error_message_sei_relationship }}
                </div>
                <div class="font-bold text-primary">
                  {{ error_message_mei_relationship }}
                </div>
                <span class="rel-note block mb-8 lg:mb-4"
                  >※一部ご加入コースにより、会員様範囲が異なる場合もございます。<br />※Beneオリジナルプランでご予約の場合、ビジター区分にあたる同行者様は入力不要です。<br />会員ご本人様を含めた会員区分の方のみご入力ください。</span
                >
                <a-divider class="custom-divider"></a-divider>
              </div>
              <div v-if="isRakutenPLan && (rakutenPolicyInfo.note || rakutenOtherInfo.otherInformation)">
                <SectionContentTitle
                  lineType="v-line"
                  titleContent="宿泊施設からのご連絡事項"
                  class="mb-4 mt-8 lg:mt-12 lg:mb-4"
                />
                <span>{{ rakutenPolicyInfo.note }}</span>
                <span>{{ rakutenOtherInfo.otherInformation }}</span>
              </div>
              <div v-if="questionList && questionList.length">
                <div class="mt-4" ref="questionListError">
                  <!-- #73662 レイアウト修正（暫定対応） -->
                  <div class="section-header">
                    <SectionContentTitle
                      lineType="v-line"
                      titleContent="宿泊施設からのご確認事項"
                      class="mt-8 lg:mt-12 section-content-title-long"
                    />
                    <span v-if="!isRakutenPLan" class="notes-text-long">{{ notesText.questionList }}</span>
                  </div>
                </div>
                <div class="checklist">
                  <div
                    class="main-checklist"
                    v-for="(i, index) in questionList"
                    :key="`questionList-${index}`"
                  >
                    <div class="checklist-title">
                      <span v-html="i.qstnCont" style="white-space: pre-wrap"></span>
                      <div class="mt-1 category" v-if="i.replyIdpsbFlag === '1'">
                        必須
                      </div>
                    </div>
                    <div class="checklist-content">
                      <div class="px-4 pt-2">
                        <a-input
                          :maxLength="maxLength"
                          v-model.trim="i.replyRem"
                          type="textarea"
                          placeholder=""
                        />
                      </div>
                    </div>
                    <div class="grid pb-2">
                      <div v-if="i.messageNote">
                        <span
                          class="ml-4 alert-message"
                          :id="`replyRemError_${index}`"
                          v-smooth-scroll
                          >この項目を入力してください</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="note-master"
                v-for="(i, index) in noteMatters"
                :key="`noteMatters-${index}`"
              >
                <div class="title">
                  {{ i.title }}
                </div>
                <div class="content" v-if="i.content">
                  <div v-html="i.content.replaceAll('\n', '<br>')"></div>
                  <div class="url">
                    <a target="_blank" :href="`${i.linkUrl}`">{{ i.linkNm }}</a>
                  </div>
                </div>
              </div>
              <div class="mt-6" ref="zipcodeForm">
                <!-- #73662 レイアウト修正（暫定対応） -->
                <div class="section-header">
                  <SectionContentTitle lineType="v-line" titleContent="申込者情報" class="mt-8 lg:mt-12 section-content-title" />
                  <span v-if="!isRakutenPLan" class="notes-text">{{ notesText.profileInfo }}</span>
                </div>
                <ZipcodeForm
                  :updateInfoComplete="checkZipcodeForm"
                  @checkValidate="checkValidateZipcode"
                  @checkProfileInfo="checkProfileInfo"
                />
              </div>
              <div class="mt-6">
                <div v-if="!isRakutenPLan">
                  <!-- #73662 レイアウト修正（暫定対応） -->
                  <div class="section-header">
                    <SectionContentTitle lineType="v-line" titleContent="宿泊代表者" class="mt-8 lg:mt-12 section-content-title" />
                    <span v-show="isShowFormInfo" class="notes-text">{{ notesText.questionList }}</span>
                  </div>
                  <div class="flex mb-3 align-center">
                    <div class="mr-6">宿泊代表者・連絡先</div>
                    <div class="mr-12">
                      <a-checkbox v-model="isShowFormInfo" :disabled="isDisabledCheckbox">
                        申込者と異なる
                      </a-checkbox>
                    </div>
                  </div>
                  <div class="form-info" v-show="isShowFormInfo || isRakutenPLan">
                    <div class="form-data mb-4">
                      <div class="content">
                        <div class="items">
                          <div class="label content__label">
                            <div>氏名（かな・ローマ字）</div>
                            <div class="mt-2">※全角かな、半角ローマ字で入力してください。</div>
                          </div>
                          <div class="items-inner">
                            <div class="data">
                              <a-input
                                :maxLength="maxLength"
                                placeholder="べねふぃっと"
                                v-model="inputFormData.familyNameKana"
                                @change="onChangeFamilyNameKana"
                                class="mr-3"
                                @blur="trimSpace"
                                wovn-ignore
                              />
                              <a-input
                                @blur="trimSpace"
                                :maxLength="maxLength"
                                placeholder="はなこ"
                                v-model="inputFormData.firstNameKana"
                                @change="onChangeFirstNameKana"
                                wovn-ignore
                              />
                            </div>
                            <div
                              class="error-notification alert-message"
                              ref="firstNameKanaError"
                            >
                              {{ inputFormData.error_message_name_kana }}
                            </div>
                          </div>
                        </div>
                        <div class="items">
                          <div class="label content__label">
                            <div>氏名（漢字・ローマ字）</div>
                            <div class="mt-2">※漢字・全角かなカナ・全角ローマ字で入力してください。</div>
                          </div>
                          <div class="items-inner">
                            <div class="data">
                              <a-input
                                @blur="trimSpace"
                                :maxLength="maxLength"
                                class="mr-3"
                                placeholder="ベネフィット"
                                v-model="inputFormData.familyName"
                                @change="onChangeFamilyName"
                                wovn-ignore
                              />
                              <a-input
                                @blur="trimSpace"
                                :maxLength="maxLength"
                                placeholder="花子"
                                v-model="inputFormData.firstName"
                                @change="onChangeFirstName"
                                wovn-ignore
                              />
                            </div>
                            <div
                              class="error-notification alert-message"
                              ref="firstNameError"
                            >
                              {{ inputFormData.error_message_name }}
                            </div>
                          </div>
                        </div>
                        <div class="items">
                          <div class="label content__label content__label--tel">
                            <div>連絡先電話番号</div>
                            <div class="mt-2">※半角数字のみをご入力してください。ハイフンの入力は不要です。</div>
                          </div>
                          <div class="items-inner">
                            <div class="data">
                              <a-input
                                class="select-items"
                                placeholder="0312345678"
                                :maxLength="11"
                                v-model="inputFormData.phoneNumber"
                                @change="onlyInputNumber"
                                wovn-ignore
                              />
                            </div>
                            <div
                              class="error-notification alert-message"
                              style="margin-left: 15px"
                              ref="ageError"
                            >
                              {{ inputFormData.error_message_age }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="buttons flex gap-2 justify-center mt-4 mb-4">
            <button @click="handleBack()" class="c-btn btn-white">
              <span class="">戻る</span>
            </button>
            <button @click="handleNext()" class="c-btn btn-grey">
              <span class="">次へ</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import _ from 'lodash'
import func_utils from '@/mixins/func_utils'
import plan_utils from '@/mixins/plan_utils'
import { Step, Item, SectionContentTitle } from '@/components/compound'
import {
  GET_MENU_STAY_PARAMS,
  GET_MESSAGE_DATA,
  GET_ITEM_DETAIL,
  GET_COUPON,
  GET_BENEPO_POINT,
  SAVE_DATA_BS_APP_02_001,
  SAVE_RELATIONSHIP
} from '@/store/modules/bs_app/actions'
import {
  SAVE_CUSTOMER_PLAN,
  IS_USE_COUPON,
  IS_USE_BENEPO_POINT
} from '@/store/modules/plan/actions'
import { SAVE_AVAILABLE_STOCK, DELETE_AVAILABLE_STOCK } from '@/store/modules/order/actions'
import PeopleOfRoomRakuten from './components/PeopleOfRoomRakuten'
import PeopleOfRoomNew from './components/PeopleOfRoomNew'
import PeopleRelationship from './components/PeopleRelationship'
import { TIME_PICKER, TIME_OPTIONS } from '@/constants/date_time'
import MESSAGE_ERROR from '@/constants/message_error'
import moment from 'moment'
import { relationship } from '@/constants/relationships'
import ZipcodeForm from '../BS_APP_02_002'
import { STEPS } from '@/constants/order.js'
import { PLAN_BASE_ON_PRICE } from '@/constants/plan'
import Mutex from '@/utils/mutex'

const MN_RESERVE_NOTHING = '9999999999'

export default {
  mixins: [func_utils, plan_utils],
  components: {
    Step,
    Item,
    SectionContentTitle,
    PeopleOfRoomRakuten,
    PeopleOfRoomNew,
    PeopleRelationship,
    ZipcodeForm
  },
  data() {
    return {
      adultTypeData: [],
      childTypeData: [],
      deputation: [],
      steps: STEPS,
      roomBasicInfo: null,
      planBasicInfo: null,
      customerPlan: null,
      menuStayParams: null,
      hasError: false,
      showForm: false,
      valueCheckbox1: false,
      valueCheckbox: false,
      totalPoint: 0,
      titleContent: ['お申し込み内容', '申込者情報'],
      lineType: { horizontal: 'h-line', vertical: 'v-line' },
      maxLength: 100,
      relationship,
      inputFormData: {
        familyName: '',
        firstName: '',
        familyNameKana: '',
        firstNameKana: '',
        phoneNumber: null,
        error_message_name: null,
        error_message_name_kana: null,
        error_message_rela: null,
        // error_message_visitor: null,
        error_message_gender: null,
        error_message_age: null
      },
      checkinTime: null,
      checkinTimeOptions: TIME_PICKER,
      checkInTimeErrorMsg: null,
      checkVehicleErrorMsg: null,
      checkRelationshipErrorMsg: null,
      options: TIME_OPTIONS,
      dataItemOrder: {},
      caution: {
        caution1:
          '※ 会員ご本人及び配偶者の各2親等以内の方は「会員」欄にご利用人数を入力してください。（一部ご加入コースにより会員様範囲が異なる場合もございます）',
        caution2:
          '※ 利用者内訳に子どもがない場合は、子どもも大人の扱いになります。（大人と同様）',
        caution3: '※ 子どもは小学生までです。',
        caution4: '※ 幼児は0才児〜未就学児までです。'
      },
      questionList: [],
      questionListErrors: [],
      errors: [],
      info_confirms: {
        description1:
          '交通手段をお知らせください。お子さま（幼児：4歳〜小学校入学前/小学生）が宿泊される場合は、年齢/男女別をお知らせください。',
        description2: '※幼児のお子さまは年齢の記入をお願いします。',
        description3:
          'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト・・・'
      },
      contact_facilities:
        '本ページにて入力いただいた内容以外に施設へ事前にお伝えしたい事項がある場合には、予約申込後、直接施設へご連絡いただきますようお願い申し上げます。（例：食品アレルギーなど）なお、予約直後は施設側での予約処理が間に合わず、予約内容の確認にお時間がかかる場合がございますので予めご了承ください。',
      gift_facilities:
        '宿泊同行者がベネフィット・ステーション会員様の場合は、申込者・同行者それぞれに50ベネポをプレゼントいたします  ※テキストテキスト・・・ ※テキストテキスト・・・・ ※テキストテキスト・・・・',
      hasCoupon: 1,
      useBenepoPoint: false,
      hasInfoDetail: false,
      error_message_note: '',
      totalFee: 0,
      timecheckin: {},
      dataRoom: {
        stayDays: [],
        member: {
          man: 0,
          woman: 0
        },
        visitors: {
          man: 0,
          woman: 0
        },
        memberChildren: {
          childrenType10: 0,
          childrenType15: 0,
          childrenType20: 0,
          childrenType30: 0,
          childrenType40: 0,
          childrenType50: 0
        },
        visitorChildren: {
          childrenType10: 0,
          childrenType15: 0,
          childrenType20: 0,
          childrenType30: 0,
          childrenType40: 0,
          childrenType50: 0
        },
        adultCount: 0,
        childrenCount: 0,
        roomAmount: 0
      },
      roomCountCheckDatas: [],
      vacancyCalendar: [],
      loadingVacancyCalendar: false,
      stayRoomDetails: [],
      tempStayRoomDetails: [],
      showRelationship: false,
      enableConfirmButton: true,
      useCoupon: false,
      roomBasicInfoNote: '',
      noteMatters: [],
      maxStayCapacity: null,
      minStayCapacity: null,
      roomErrors: [],
      deputationErrors: [],
      bothRoomError: [],
      isValidateNative: false,
      isValidateBack: true,
      subsidyList: null,
      totalAdult: undefined,
      vehicles: [
        {
          label: '車',
          value: '10'
        },
        {
          label: '公共交通機関',
          value: '20'
        }
      ],
      moveDiv: null,
      grantedBenepo: null,
      totalAdultCntMember: null,
      checkSaveRelationship: false,
      error_message_age_relationship: '',
      error_message_sei_relationship: '',
      error_message_mei_relationship: '',
      isReRenderListRoom: false,
      showRelationName: false,
      isShowFormInfo: false,
      checkZipcodeForm: false,
      isErrorZipcode: false,
      // 以下2つのオブジェクトは楽天の施設情報要オブジェクト
      // 楽天APIのレスポンスに形を併せており、データの追加に対応する
      rakutenPolicyInfo: {
        note: null
      },
      rakutenOtherInfo: {
        otherInformation: null
      },
      errorSameValue:'',
      tempStayDayDetails: null,
      isNextClickEnabled: true,
      mutex: new Mutex(),
      // #73662 レイアウト修正（暫定対応）
      notesText: {
        questionList: "※絵文字・記号・異体字・旧字はご利用できません。",
        profileInfo: "※氏名・住所に絵文字・異体字・旧字が含まれる場合、予約に失敗する可能性があります。文字を修正して入力してください。氏名の変更は宿泊代表者欄にて修正をお願いします。",
        representativeFormInfo: "※絵文字・記号・異体字・旧字はご利用できません。"
      },
      shouldUpdateRelationships: false,
      cacheRelationships: {}, // #76074：続柄情報のキャッシュ
    }
  },
  filters: {
    separatedByCommas(value) {
      return Number(value).toLocaleString()
    }
  },
  created() {
    this.customerPlan = this.customerPlanState
    this.useCoupon = !!this.$store.getters.isUseCoupon
    this.useBenepoPoint = !!this.$store.getters.isUseBenepoPoint
    this.subsidyList = _.get(this.customerPlan, 'subsidyList', null)
    this.maxStayCapacity = _.get(this.customerPlan, 'maxStayCapacity', null)
    this.minStayCapacity = _.get(this.customerPlan, 'minStayCapacity', null)
    const toPlanDetailFrom = _.get(this.customerPlan, 'toPlanDetailFrom', null)
    const screenData = this.bsApp02001Data
    this.getPlanBasicInfo()
    this.renderCheckinTime()
    this.fetchSubsidySettingBasicList()
    /**
     * EXIST SCREEN DATA
     */
    if (screenData) {
      this.checkinTime = screenData.checkinTime
      this.moveDiv = _.get(screenData, 'othInfo.moveDiv', null)
      this.valueCheckbox1 = screenData.valueCheckbox1
      this.valueCheckbox = screenData.valueCheckbox
      if(screenData.inputFormData){
        this.isShowFormInfo = true
        Object.assign(this.inputFormData, { ...screenData.inputFormData })
      }
      // GO FROM PLAN DETAILS TO
      // ARRANGE PEOPLE INTO EACH ROOM
      if (toPlanDetailFrom) {
        this.questionList = screenData.questionList
        this.questionListErrors = []
        this.questionList.forEach((e) => {
          this.questionListErrors.push({
            message: ''
          })
        })
        this.arrangeIntoRoom()
      } else {
        // map errors
        screenData.stayRoomDetails.forEach(() => {
          this.roomErrors.push({
            errors: []
          })
          // deputation Errors
          this.deputationErrors.push({
            errors: {}
        })
        })
        this.tempStayRoomDetails = _.cloneDeep(screenData.stayRoomDetails)
        this.questionList = screenData.questionList
        this.questionListErrors = []
        this.questionList.forEach((e) => {
          this.questionListErrors.push({
            message: ''
          })
        })
      }
      this.getNoteMaterFromState()
      
      // #76074：ストアに保存されている続柄情報がある場合はキャッシュにセット
      const tempRoomsMemberCnt = {}
      this.tempStayRoomDetails.forEach((room) => {
        // 続柄選択は会員のみなので部屋ごとに会員人数カウント
        tempRoomsMemberCnt[room.roomNo] = {
          adult: room.member.man + room.member.woman,
          child: room.memberChildren.childrenType10 + room.memberChildren.childrenType15 + room.memberChildren.childrenType20 + room.memberChildren.childrenType30 + room.memberChildren.childrenType40 + room.memberChildren.childrenType50,
        }
      })
      const relationshipsMemberCnt = {}
      screenData.stayRoomDetails.forEach((room) => {
        if (room.relationships && room.relationships.length > 0) {
          // 続柄情報があれば部屋ごとに人数カウント
          relationshipsMemberCnt[room.roomNo] = {
            adult: 0,
            child: 0
          }
          room.relationships.forEach((relationship) => {
            if (relationship.isMember) {
              if (relationship.isChildren) {
                // 会員且つ子ども＝子ども
                relationshipsMemberCnt[room.roomNo].child += 1
              } else {
                // 会員且つ子どもでない＝大人
                relationshipsMemberCnt[room.roomNo].adult += 1
              }
            }
          })
          if (tempRoomsMemberCnt[room.roomNo].adult === relationshipsMemberCnt[room.roomNo].adult &&
              tempRoomsMemberCnt[room.roomNo].child === relationshipsMemberCnt[room.roomNo].child) {
            // 部屋ごとの人数カウントが一致していれば続柄情報をキャッシュに保存
            this.cacheRelationships[room.roomNo] = room.relationships
          }
        }
      })
      if (Object.keys(this.cacheRelationships).length === 0) {
        // 続柄情報のキャッシュがない場合は続柄情報表示フラグをfalseにする
        screenData.showRelationship = false
      }
    } else {
      this.arrangeIntoRoom()
      this.getQuestionList()
    }
    this.tempStayRoomDetails.forEach((e, idx) => {
      this.deputation[idx] = {
        familyName: null,
        familyNameKana: null,
        firstName: null,
        firstNameKana: null,
        gender: null,
        age: null,
        numRoom: idx,
        isDeputation: false
      }
    })
    // Redmine#72095：申込確認画面から戻った際、宿泊代表者のフラグが初期（未チェック）状態のままになっている
    // 戻った際に過去に入力した情報で、宿泊代表者関連の情報も追加で入れる
    // 上記の this.deputation の設定後に入れる必要があるため、この位置に実装
    // 申込入力画面からプラン詳細画面に戻り、部屋数を減らした際も考慮
    if (screenData) {
      if (this.deputation.length <= screenData.deputyInfo.length) {
        this.deputation.forEach((obj, index) => {
          this.deputation[index] = screenData.deputyInfo[index];
        })
      } else {
        screenData.deputyInfo.forEach((obj, index) => {
          this.deputation[index] = screenData.deputyInfo[index];
        })
      }
    }
  },
  mounted() {
    let orderData = _.get(this.$store.state, 'order.originCalendar', null)
    if (orderData === null) {
      this.$router.push("/interrupt")
      return
    }

    if (this.isRakutenPLan) {
      this.isShowFormInfo = true

      // 以下の関数はmethodsプロパティ内に定義
      this.getRakutenInformation();
    }
    this.getBenepoPoint()
    const screenData = this.bsApp02001Data
    this.$nextTick(() => {
      if (screenData) {
        this.showRelationship = screenData.showRelationship
        this.checkSaveRelationship = screenData.checkSaveRelationship
      }
      this.calculateAmount
    })

    this.handleDeleteSlot()
  },
  computed: {
    isRakutenPLan() {
      return _.get(this.getPlanInfo, 'menuInformation.extSystemCd') === 'RakutenT'
    },
    baseOnPrice() {
      return this.$store.getters.baseOnPrice
    },
    getPlanInfo() {
      return _.cloneDeep(_.get(this.$store.state, 'plan.planDetail', null))
    },
    customerPlanState() {
      return _.cloneDeep(this.$store.getters.customerPlan)
    },
    bsApp02001Data() {
      return _.cloneDeep(_.get(this.$store.getters.bs_app, 'bs_app_02_001', null))
    },
    savedAdultTypeData() {
      return this.bsApp02001Data?.adultTypeData ?? []
    },
    savedChildTypeData() {
      return this.bsApp02001Data?.childTypeData ?? []
    },
    savedDeputyInfo() {
      return this.bsApp02001Data?.deputyInfo ?? []
    },
    calculateTotalAmount() {
      let amount = 0
      if (this.baseOnPrice === PLAN_BASE_ON_PRICE.ROOM) {
        if (this.stayRoomDetails && this.stayRoomDetails[0]) {
          // 宿泊料金の合計
          if (Array.isArray(this.stayRoomDetails)) {
            this.stayRoomDetails.forEach((stayRoom) => {
              if (Array.isArray(stayRoom.stayDays)) {
                stayRoom.stayDays.forEach((stayDays) => {
                  amount += stayDays.price ? Math.round(stayDays.price) : 0
                })
              }
            })
          }
        }
      } else {
        if (this.stayRoomDetails && Array.isArray(this.stayRoomDetails)) {
          this.stayRoomDetails.forEach((el) => {
            amount += el.roomAmount ? Math.round(el.roomAmount) : 0
          })
        }
      }
      return amount ? Math.round(amount) : amount
    },

    countAdultPeople() {
      let count = 0
      if (this.stayRoomDetails && Array.isArray(this.stayRoomDetails)) {
        this.stayRoomDetails.forEach((el) => {
          const members =
            (el.member && el.member.man ? +el.member.man : 0) +
            (el.member && el.member.woman ? +el.member.woman : 0)
          const visitors =
            (el.visitors && el.visitors.man ? +el.visitors.man : 0) +
            (el.visitors && el.visitors.woman ? +el.visitors.woman : 0)
          count += members + visitors
        })
      }
      return count
    },
    totalChildren() {
      return Array.isArray(this.stayRoomDetails)
        ? this.stayRoomDetails
            .map((item) => item.childrenCount)
            .reduce((a, b) => a + b, 0)
        : 0
    },
    totalPeopleCnt() {
      return this.countAdultPeople + this.totalChildren
    },
    inputFormDataWatch() {
      let result = ''
      for (const key in this.inputFormData) {
        if (!key.includes('error')) result += this.inputFormData[key]
      }
      return result
    },
    isDisabledCheckbox() {
      return (
        this.totalPeopleCnt <= 1 &&
        this.stayRoomDetails?.[0]?.relationships?.[0]?.relationshipCode === 'C-0-0'
      )
    },
    isRakuten() {
      return _.get(this.getPlanInfo, 'menuInformation.extSystemCd', null) === 'RakutenT';
    },
    getDeputationErrors() {
      return (idx) => this.deputationErrors?.[idx]?.errors || {};
    }
  },
  watch: {
    async calculateTotalAmount(val) {
      this.grantedBenepo = 0
      const { menuNo, planId } = this.$route.query
      if (menuNo && planId) {
      this.grantedBenepo = await this.getGrantedBenepoStay()
      }
    },
    totalPeopleCnt() {
      this.showRelationship = false
    },
    inputFormDataWatch() {
      if (!this.isValidateNative) return
      this.validateRepresentivePeople()
    },
    isShowFormInfo() {
      this.inputFormData.error_message_name = null
      this.inputFormData.error_message_name_kana = null
      this.inputFormData.error_message_age = null
    }
  },

  methods: {
    checkProfileInfo(data) {
      this.isErrorZipcode = data
    },
    checkValidateZipcode(data) {
      this.isErrorZipcode = data
      this.checkZipcodeForm = false
    },
    showFormInfo() {
      this.isShowFormInfo = !this.isShowFormInfo
    },
    enableNextMonth() {
      const stayDay = this.customerPlan.stayDay
      const stayNights = this.customerPlan.stayNights
      if (
        moment(stayDay)
          .add(stayNights - 1, 'days')
          .isAfter(stayDay, 'month')
      ) {
        return true
      }
      return false
    },
    async getVacancyCalendar() {
      let hasError = false;
      const stayDay = this.customerPlan.stayDay
      const stayNights = this.customerPlan.stayNights
      const { menuNo, planId, roomId } = this.$route.query
      const checkInDay = moment(stayDay).format('YYYY/MM/DD')
      let checkOutDay = moment(stayDay).add(stayNights, 'days').format('YYYY/MM/DD')

      if (moment(stayDay).isBefore(checkOutDay, 'month')) {
        checkOutDay = moment(stayDay).endOf('month').format('YYYY/MM/DD')
      }

      const clonedCalenders  = []
      this.roomCountCheckDatas = [];
      for (let i = 0; i < this.tempStayRoomDetails.length; i++) {
        const stayRoomDetail = this.tempStayRoomDetails[i]
        const roomCountCheckData = {
          roomNo: stayRoomDetail.roomNo,
          vacancyCalendar:[],
          vacancyCalenderError:false
        }
        // 64187：布団なし幼児はvacancyCalendar側でカウントから除外されており、「大人料金計算時に数える」の設定もvacancyCalendar側で加味されているため、現行の処理で問題なし
        const childrenType10 = stayRoomDetail.memberChildren.childrenType10 + stayRoomDetail.visitorChildren.childrenType10
        const childrenType15 = stayRoomDetail.memberChildren.childrenType15 + stayRoomDetail.visitorChildren.childrenType15
        const childrenType20 = stayRoomDetail.memberChildren.childrenType20 + stayRoomDetail.visitorChildren.childrenType20
        const childrenType30 = stayRoomDetail.memberChildren.childrenType30 + stayRoomDetail.visitorChildren.childrenType30
        const childrenType40 = stayRoomDetail.memberChildren.childrenType40 + stayRoomDetail.visitorChildren.childrenType40
        const childrenType50 = stayRoomDetail.memberChildren.childrenType50 + stayRoomDetail.visitorChildren.childrenType50

        const adultHeadCnt = stayRoomDetail.member.man + stayRoomDetail.visitors.man +
          stayRoomDetail.member.woman + stayRoomDetail.visitors.woman

        let vacancyData = {
          menuNo,
          planId,
          roomId,
          queryParams: {
            checkInDay,
            checkOutDay,
            roomCnt: this.customerPlan.stayRooms,
            adultHeadCnt ,
            exUpperGradesHeadCnt: childrenType10 ,
            exLowerGradesHeadCnt: childrenType15 ,
            youjiAHeadCnt: childrenType20 ,
            youjiBHeadCnt: childrenType30 ,
            youjiCHeadCnt: childrenType40 ,
            youjiDHeadCnt: childrenType50
          }
        }

        this.$loading.show()
        this.loadingVacancyCalendar = true
        const result = await this.$repositories('plan')
          .getVacancyCalendar(vacancyData)
          .catch((error) => {
            roomCountCheckData.vacancyCalenderError = true;
            this.roomCountCheckDatas.push(roomCountCheckData);
            return false
          })

        if (!result || result.error) {
          this.$loading.hide()
          this.loadingVacancyCalendar = false
          this.vacancyCalendar = []
          roomCountCheckData.vacancyCalenderError = true;
          this.roomCountCheckDatas.push(roomCountCheckData);
          hasError = true;
        }
        
        let clonedResult = _.cloneDeep(result)
        
        if (this.enableNextMonth()) {
          vacancyData = _.cloneDeep(vacancyData)
          vacancyData.queryParams.checkInDay = moment(stayDay)
            .add(1, 'month')
            .startOf('month')
            .format('YYYY/MM/DD')
          vacancyData.queryParams.checkOutDay = moment(stayDay)
            .add(stayNights, 'days')
            .format('YYYY/MM/DD')
          const result2 = await this.$repositories('plan')
            .getVacancyCalendar(vacancyData)
            .catch((error) => {
              roomCountCheckData.vacancyCalenderError = true;
              this.roomCountCheckDatas.push(roomCountCheckData);
              return false
            })
          if (!result2 || result2.error) {
            this.$loading.hide()
            this.loadingVacancyCalendar = false
            roomCountCheckData.vacancyCalenderError = true;
            this.roomCountCheckDatas.push(roomCountCheckData);
            hasError = true;
          }
          // #78277 vacancyClarendarsが空の状態の場合、concatで処理が中断するためif文を実装。
          if(clonedResult.vacancyCalendars && result2.vacancyCalendars) { 
            clonedResult.vacancyCalendars = clonedResult.vacancyCalendars.concat(result2.vacancyCalendars)
          }else{
            clonedResult = [];
          // #78277 concatスキップ時、clonedResultに一律で空配列が代入されるよう追加改修。
          }
        }

        // add spec round to decimal for adultPrice, childPrice, price
        clonedResult?.vacancyCalendars?.map((item) => {
          item.price = Math.round(item.price)
          item.adultPrice = Math.round(item.adultPrice)
          item?.childrenPriceTable?.map((child) => {
            child.price = Math.round(child.price)
            child.childPrice = Math.round(child.childPrice)
            child.boneSubsidy = Math.round(child.boneSubsidy)
          })
        })
        this.tempStayRoomDetails[i].vacancyCalendar = clonedResult
        roomCountCheckData.vacancyCalendar = clonedResult;
        this.roomCountCheckDatas.push(roomCountCheckData);
        clonedCalenders.push(clonedResult)
      }
      this.$loading.hide()
      this.loadingVacancyCalendar = false
      this.vacancyCalendar = clonedCalenders
      return !hasError
    },
    onChangeFamilyNameKana(e) {
      const input = e.target.value
      this.inputFormData.familyNameKana = this.onReplaceKanaRomajiNew(input)
    },
    onChangeFirstNameKana(e) {
      const input = e.target.value
      this.inputFormData.firstNameKana = this.onReplaceKanaRomajiNew(input)
    },
    onChangeFamilyName(e) {
      const input = e.target.value
      this.inputFormData.familyName = this.onReplaceKanjiRomajiNew(input)
    },
    onChangeFirstName(e) {
      const input = e.target.value
      this.inputFormData.firstName = this.onReplaceKanjiRomajiNew(input)
    },
    onlyInputNumber(e) {
      const input = e.target.value
      this.inputFormData.phoneNumber = this.inputPhonenumber(input)
    },
    onRelationshipChange($event) {
      if (this.showRelationship) {
        this.stayRoomDetails = $event
        // #76074：roomNoをキーに続柄情報のみをキャッシュしておく
        this.stayRoomDetails.forEach(room => {
          if (room?.roomNo != null && room.relationships.length > 0) {
            this.cacheRelationships[room.roomNo] = _.cloneDeep(room.relationships);
          }
        });
      }
    },
    getAdultCntMember($event) {
      this.totalAdultCntMember = $event
    },
    async onChangePeopleCnt($event) {
      // ONLY CHECK PEOPLE NUMBER CHANGE
      await this.getVacancyCalendar()
      this.applyChange()
      this.validateRoom()
    },
    async onchangePersonType() {
      // 75972 ベネ楽プランで年齢区分変更時にvacancy-calender APIを実行するよう改修
      await this.getVacancyCalendar()
      this.applyChange()
      this.validateRoom()
    },
    onChangeRoom($event) {
      // CHECK ALL CHANGE: PEOPLE NUMBER, AMOUNT,...
      if (!this.loadingVacancyCalendar) {
        this.applyChange()
        this.validateRoom()
      }
    },
    onChangeDeputation(people, numRoom) {
      this.deputation[numRoom] = Object.assign(this.deputation[numRoom], people)
      this.validateDeputation(numRoom)
    },
    onChangeRepresentative(representative, numRoom) {
      this.deputation[numRoom] = Object.assign(this.deputation[numRoom], representative)
      if (numRoom === 0) {
        this.inputFormData = Object.assign(this.inputFormData, representative)
      }
      this.validateDeputation(numRoom)
    },
    onChangeAdultTypeData(adultTypeData, numRoom, updateFlag = false) {
      this.adultTypeData[numRoom] = adultTypeData
      // 年齢区分の各項目を変更した時のみ渡す値を変更する（ロード時は含めない）
      this.shouldUpdateRelationships = updateFlag === true
    },
    onChangeChildTypeData(childTypeData, numRoom, updateFlag = false) {
      this.childTypeData[numRoom] = childTypeData
      // 年齢区分の各項目を変更した時のみ渡す値を変更する（ロード時はfalse）
      this.shouldUpdateRelationships = updateFlag === true
    },
    applyChange() {
      this.stayRoomDetails = _.cloneDeep(this.tempStayRoomDetails)
      this.updateStayRoomData()
    },
    arrangeIntoRoom() {
      if (!this.customerPlan) {
        return
      }
      const stayRooms = this.customerPlan.stayRooms
      const memberChldDetails = this.customerPlan.memberChldDetails
      const visitorChldDetails = this.customerPlan.visitorChldDetails
      const spreadPeopleList = []
      for (let i = 0; i < this.customerPlan.memberAdults * stayRooms; i++) {
        spreadPeopleList.push({
          type: 'member'
        })
      }
      for (let i = 0; i < this.customerPlan.visitorAdults * stayRooms; i++) {
        spreadPeopleList.push({
          type: 'visitor'
        })
      }
      Object.keys(memberChldDetails)
        .map((key) => ({ value: memberChldDetails[key], key }))
        .forEach((e) => {
          for (let i = 0; i < e.value * stayRooms; i++) {
            spreadPeopleList.push({
              type: 'member_chld',
              key: e.key
            })
          }
        })
      Object.keys(visitorChldDetails)
        .map((key) => ({ value: visitorChldDetails[key], key }))
        .forEach((e) => {
          for (let i = 0; i < e.value * stayRooms; i++) {
            spreadPeopleList.push({
              type: 'visitor_chld',
              key: e.key
            })
          }
        })
      const roomErrors = []
      const stayRoomDetails = []
      const deputationErrors = [] 
      for (let i = 0; i < stayRooms; i++) {
        const roomData = _.cloneDeep(this.dataRoom)
        roomData.roomNo = i + 1
        roomData.stayDays = Array.isArray(this.customerPlan.detailDays)
          ? this.customerPlan.detailDays
          : []
        roomData.member.man = 0
        roomData.visitors.man = 0
        roomData.chldaManHeadCnt = 0
        roomData.chldaWomanHeadCnt = 0
        roomData.adultCount = 0
        roomData.childrenCount = 0
        roomData.roomAmount = 0
        roomData.memberChildren = {
          childrenType10: 0,
          childrenType15: 0,
          childrenType20: 0,
          childrenType30: 0,
          childrenType40: 0,
          childrenType50: 0
        }
        roomData.visitorChildren = {
          childrenType10: 0,
          childrenType15: 0,
          childrenType20: 0,
          childrenType30: 0,
          childrenType40: 0,
          childrenType50: 0
        }
        roomData.relationships = []
        roomErrors.push({
          errors: []
        })
        deputationErrors.push({ errors: {} })
        stayRoomDetails.push(roomData)
      }
      this.roomErrors = roomErrors
      this.tempStayRoomDetails = stayRoomDetails
      this.deputationErrors = deputationErrors

      while (spreadPeopleList.length > 0) {
        for (let j = 0; j < this.tempStayRoomDetails.length; j++) {
          const people = spreadPeopleList.shift()
          if (people && people.type) {
            switch (people.type) {
              case 'member':
                this.tempStayRoomDetails[j].member.man += 1
                this.tempStayRoomDetails[j].adultCount += 1
                break
              case 'visitor':
                this.tempStayRoomDetails[j].visitors.man += 1
                this.tempStayRoomDetails[j].adultCount += 1
                break
              case 'member_chld':
                this.tempStayRoomDetails[j].childrenCount += 1
                if (people.key === 'childrenType10') {
                  this.tempStayRoomDetails[j].memberChildren['childrenType10'] += 1
                } else if (people.key === 'childrenType15') {
                  this.tempStayRoomDetails[j].memberChildren['childrenType15'] += 1
                } else if (people.key === 'childrenType20') {
                  this.tempStayRoomDetails[j].memberChildren['childrenType20'] += 1
                } else if (people.key === 'childrenType30') {
                  this.tempStayRoomDetails[j].memberChildren['childrenType30'] += 1
                } else if (people.key === 'childrenType40') {
                  this.tempStayRoomDetails[j].memberChildren['childrenType40'] += 1
                } else if (people.key === 'childrenType50') {
                  this.tempStayRoomDetails[j].memberChildren['childrenType50'] += 1
                }
                break
              case 'visitor_chld':
                this.tempStayRoomDetails[j].childrenCount += 1
                if (people.key === 'childrenType10') {
                  this.tempStayRoomDetails[j].visitorChildren['childrenType10'] += 1
                } else if (people.key === 'childrenType15') {
                  this.tempStayRoomDetails[j].visitorChildren['childrenType15'] += 1
                } else if (people.key === 'childrenType20') {
                  this.tempStayRoomDetails[j].visitorChildren['childrenType20'] += 1
                } else if (people.key === 'childrenType30') {
                  this.tempStayRoomDetails[j].visitorChildren['childrenType30'] += 1
                } else if (people.key === 'childrenType40') {
                  this.tempStayRoomDetails[j].visitorChildren['childrenType40'] += 1
                } else if (people.key === 'childrenType50') {
                  this.tempStayRoomDetails[j].visitorChildren['childrenType50'] += 1
                }
                break
            }
          }
        }
      }
    },
    updateStayDays() {
      for (let i = 0; i < this.stayRoomDetails.length; i++) {
        const vacancyCalendars = _.get(this.vacancyCalendar[i], 'vacancyCalendars') || []

        const stayRoom = this.stayRoomDetails[i]
        let stayDays = _.cloneDeep(this.stayRoomDetails[i].stayDays)

        const memberAdultCnt = stayRoom.member.man + stayRoom.member.woman
        const visitorAdultCnt = stayRoom.visitors.man + stayRoom.visitors.woman

        const memberChldCnt = Object.keys(stayRoom.memberChildren)
          .map((key) => stayRoom.memberChildren[key])
          .reduce((a, b) => a + b, 0)
        const visitorChldCnt = Object.keys(stayRoom.visitorChildren)
          .map((key) => stayRoom.visitorChildren[key])
          .reduce((a, b) => a + b, 0)
        stayDays = stayDays.map((day) => {
          // get newest vacancy data
          const calendarDay = _.get(
            vacancyCalendars.filter((v) => moment(v.stayDay).isSame(day.stayDay, 'day')),
            '[0]',
            null
          )
          day.price = _.get(calendarDay, 'price', null)
          day.adultPrice = _.get(calendarDay, 'adultPrice', null)
          day.boneSubsidy = _.get(calendarDay, 'boneSubsidy', null)
          day.roomPrice = _.get(calendarDay, 'roomPrice', null)
          day.childrenPriceTable = _.get(calendarDay, 'childrenPriceTable', null)
          day.memberAdultCnt = memberAdultCnt
          day.memberAdultPrice = day.price
          day.memberAdultChrg = memberAdultCnt * day.price
          day.visitorAdultCnt = visitorAdultCnt
          day.visitorAdultPrice = day.adultPrice
          day.visitorAdultChrg = visitorAdultCnt * day.adultPrice
          day.memberChldCnt = {
            childrenType10: stayRoom.memberChildren.childrenType10,
            childrenType15: stayRoom.memberChildren.childrenType15,
            childrenType20: stayRoom.memberChildren.childrenType20,
            childrenType30: stayRoom.memberChildren.childrenType30,
            childrenType40: stayRoom.memberChildren.childrenType40,
            childrenType50: stayRoom.memberChildren.childrenType50
          }
          day.memberChldPrice = {
            childrenType10: this.getMemberChildPrice('childrenType10', day.childrenPriceTable),
            childrenType15: this.getMemberChildPrice('childrenType15', day.childrenPriceTable),
            childrenType20: this.getMemberChildPrice('childrenType20', day.childrenPriceTable),
            childrenType30: this.getMemberChildPrice('childrenType30', day.childrenPriceTable),
            childrenType40: this.getMemberChildPrice('childrenType40', day.childrenPriceTable),
            childrenType50: this.getMemberChildPrice('childrenType50', day.childrenPriceTable)
          }
          day.memberChldChrg = {
            childrenType10:
              stayRoom.memberChildren.childrenType10 * day.memberChldPrice.childrenType10,
            childrenType15:
              stayRoom.memberChildren.childrenType15 * day.memberChldPrice.childrenType15,
            childrenType20:
              stayRoom.memberChildren.childrenType20 * day.memberChldPrice.childrenType20,
            childrenType30:
              stayRoom.memberChildren.childrenType30 * day.memberChldPrice.childrenType30,
            childrenType40:
              stayRoom.memberChildren.childrenType40 * day.memberChldPrice.childrenType40,
            childrenType50:
              stayRoom.memberChildren.childrenType50 * day.memberChldPrice.childrenType50
          }
          day.totalMemberChldCnt = memberChldCnt
          day.totalMemberChldChrg = Object.keys(day.memberChldChrg)
            .map((key) => day.memberChldChrg[key])
            .reduce((a, b) => a + b, 0)

          day.visitorChldCnt = {
            childrenType10: stayRoom.visitorChildren.childrenType10,
            childrenType15: stayRoom.visitorChildren.childrenType15,
            childrenType20: stayRoom.visitorChildren.childrenType20,
            childrenType30: stayRoom.visitorChildren.childrenType30,
            childrenType40: stayRoom.visitorChildren.childrenType40,
            childrenType50: stayRoom.visitorChildren.childrenType50
          }
          day.visitorChldPrice = {
            childrenType10: this.getVisitorChildPrice('childrenType10', day.childrenPriceTable),
            childrenType15: this.getVisitorChildPrice('childrenType15', day.childrenPriceTable),
            childrenType20: this.getVisitorChildPrice('childrenType20', day.childrenPriceTable),
            childrenType30: this.getVisitorChildPrice('childrenType30', day.childrenPriceTable),
            childrenType40: this.getVisitorChildPrice('childrenType40', day.childrenPriceTable),
            childrenType50: this.getVisitorChildPrice('childrenType50', day.childrenPriceTable)
          }
          day.visitorChldChrg = {
            childrenType10:
              stayRoom.visitorChildren.childrenType10 * day.visitorChldPrice.childrenType10,
            childrenType15:
              stayRoom.visitorChildren.childrenType15 * day.visitorChldPrice.childrenType15,
            childrenType20:
              stayRoom.visitorChildren.childrenType20 * day.visitorChldPrice.childrenType20,
            childrenType30:
              stayRoom.visitorChildren.childrenType30 * day.visitorChldPrice.childrenType30,
            childrenType40:
              stayRoom.visitorChildren.childrenType40 * day.visitorChldPrice.childrenType40,
            childrenType50:
              stayRoom.visitorChildren.childrenType50 * day.visitorChldPrice.childrenType50
          }
          day.totalVisitorChldCnt = visitorChldCnt
          day.totalVisitorChldChrg = Object.keys(day.visitorChldChrg)
            .map((key) => day.visitorChldChrg[key])
            .reduce((a, b) => a + b, 0)
          return day
        })
        this.stayRoomDetails[i].stayDays = stayDays
      }
    },
    countRoomSlots(room) {
      let slots = +room.adultCount
      Object.keys(room.memberChildren).forEach((key) => {
        if (!['childrenType30', 'childrenType50'].includes(key)) {
          slots += +room.memberChildren[key]
        }
      })
      Object.keys(room.visitorChildren).forEach((key) => {
        if (!['childrenType30', 'childrenType50'].includes(key)) {
          slots += +room.visitorChildren[key]
        }
      })
      return slots
    },
    confirmRoomPeople() {
      if (!this.validateRoom()) {
        return
      }
      this.isReRenderListRoom = true
      setTimeout(() => {
        this.isReRenderListRoom = false
      }, 500)
      this.showRelationship = true
      // #76074：続柄情報の初期化
      this.cacheRelationships = {}
      this.stayRoomDetails.forEach(room => {
        room.relationships = []
      })
    },
    getMessageData() {
      this.$store.dispatch(GET_MESSAGE_DATA).then((data) => {
        this.caution = data.caution
        this.info_confirms = data.info_confirms
        this.contact_facilities = data.contact_facilities
        this.gift_facilities = data.gift_facilities
      })
    },
    getQuestionList() {
      const detailDays = this.customerPlan ? this.customerPlan.detailDays : null
      let lengthOfDetaildays = 0
      if (Array.isArray(detailDays)) {
        lengthOfDetaildays = detailDays.length
      } else {
        return
      }

      const { menuNo, planId, roomId, adultHeadCnt , exUpperGradesHeadCnt, exLowerGradesHeadCnt, youjiAHeadCnt, youjiBHeadCnt, youjiCHeadCnt, youjiDHeadCnt} = this.$route.query
      const params = {
        menuNo,
        planId,
        roomId,
        checkInDay: detailDays[0].stayDay,
        checkOutDay: detailDays[lengthOfDetaildays - 1].stayDay,
        adultHeadCnt: adultHeadCnt || 1,
        exUpperGradesHeadCnt: exUpperGradesHeadCnt || 0,
        exLowerGradesHeadCnt: exLowerGradesHeadCnt || 0,
        youjiAHeadCnt: youjiAHeadCnt || 0,
        youjiBHeadCnt: youjiBHeadCnt || 0,
        youjiCHeadCnt: youjiCHeadCnt || 0,
        youjiDHeadCnt: youjiDHeadCnt || 0,
      }

      this.$store.dispatch(GET_MENU_STAY_PARAMS, params).then(
        (data) => {
          this.menuStayParams = _.cloneDeep(data)
          this.noteMatters = data.cautions
          if (data?.questions && Array.isArray(data.questions)) {
            this.questionListErrors = []
            this.questionList = data.questions.map((qst) => {
              this.questionListErrors.push({
                message: ''
              })
              qst.replyRem = ''
              return qst
            })
          }
          // CRM独自対応
          // this.$dataLayer.overwrite({
          //   event: process.env.VUE_APP_GTM_EVENT_ORDER_COMPLETE,
          //   menuNo: data.menuBasicInfo?.menuNo,
          //   menuName: data.menuBasicInfo?.menuNm,
          //   planId: data.planBasicInfo?.planId,
          //   planName: data.planBasicInfo?.planNm,
          //   catLrgClass: data.menuBasicInfo?.categoryInfomation?.catLrgClassCd,
          //   catMidClass: data.menuBasicInfo?.categoryInfomation?.catMidClassCd,
          //   catSmlClass: data.menuBasicInfo?.categoryInfomation?.catSmlClassCd,
          //   menuImageUrl: data.menuBasicInfo?.menuImages[0]?.imageUrl,
          //   planImageUrl: data.planBasicInfo?.planImages[0]?.imageUrl,
          // })
        },
        (error) => {}
      )
    },
    getNoteMaterFromState() {
      const detailDays = this.customerPlan ? this.customerPlan.detailDays : null
      let lengthOfDetaildays = 0
      if (Array.isArray(detailDays)) {
        lengthOfDetaildays = detailDays.length
      } else {
        return
      }
      const { menuNo, planId, roomId, adultHeadCnt, exUpperGradesHeadCnt, exLowerGradesHeadCnt, youjiAHeadCnt, youjiBHeadCnt, youjiCHeadCnt, youjiDHeadCnt } = this.$route.query
      const params = {
        menuNo,
        planId,
        roomId,
        checkInDay: detailDays[0].stayDay,
        checkOutDay: detailDays[lengthOfDetaildays - 1].stayDay,
        adultHeadCnt: adultHeadCnt || 1,
        exUpperGradesHeadCnt: exUpperGradesHeadCnt || 0,
        exLowerGradesHeadCnt: exLowerGradesHeadCnt || 0,
        youjiAHeadCnt: youjiAHeadCnt || 0,
        youjiBHeadCnt: youjiBHeadCnt || 0,
        youjiCHeadCnt: youjiCHeadCnt || 0,
        youjiDHeadCnt: youjiDHeadCnt || 0,
      }
      this.$store.dispatch(GET_MENU_STAY_PARAMS, params).then(
        (data) => {
          this.menuStayParams = _.cloneDeep(data)
          this.noteMatters = data.cautions
          // CRM独自対応
          // this.$dataLayer.overwrite({
          //   event: process.env.VUE_APP_GTM_EVENT_ORDER_COMPLETE,
          //   menuNo: data.menuBasicInfo?.menuNo,
          //   menuName: data.menuBasicInfo?.menuNm,
          //   planId: data.planBasicInfo?.planId,
          //   planName: data.planBasicInfo?.planNm,
          //   catLrgClass: data.menuBasicInfo?.categoryInfomation?.catLrgClassCd,
          //   catMidClass: data.menuBasicInfo?.categoryInfomation?.catMidClassCd,
          //   catSmlClass: data.menuBasicInfo?.categoryInfomation?.catSmlClassCd,
          //   menuImageUrl: data.menuBasicInfo?.menuImages[0]?.imageUrl,
          //   planImageUrl: data.planBasicInfo?.planImages[0]?.imageUrl,
          // })
        },
        (error) => {}
      )
    },
    getCoupon(id = 1) {
      this.$store.dispatch(GET_COUPON, id).then((data) => {
        this.hasCoupon = data.coupon.length
      })
    },
    getItemDetail() {
      this.$store.dispatch(GET_ITEM_DETAIL).then((data) => {
        if (data !== null) {
          this.dataItemOrder = data.dataItemOrder
        }
      })
    },
    getPlanBasicInfo() {
      this.planBasicInfo = this.getPlanInfo ? this.getPlanInfo.planBasicInfo : null
      this.roomBasicInfo = this.getPlanInfo ? this.getPlanInfo.roomBasicInfo : null
      if (this.planBasicInfo) {
        this.dataItemOrder = {
          type: 'type-small',
          menu_id: _.get(this.planBasicInfo, 'menuNo', ''),
          label: _.get(this.getPlanInfo, 'menuInformation.categoryInfomation', ''),
          baseImg: _.get(this.planBasicInfo, 'planImages[0].imageUrl', ''),
          title1: _.get(this.getPlanInfo, 'menuInformation.menuNm', ''),
          title2: _.get(this.planBasicInfo, 'planNm', '')
        }
      }
      if (this.roomBasicInfo) {
        this.roomBasicInfoNote = this.roomBasicInfo.note
      }
    },
    renderCheckinTime() {
      const usageDetailStay = _.get(this.getPlanInfo, 'planUsage.usageDetailStay', null)
      if (usageDetailStay) {
        const timeCheckIn = usageDetailStay.checkInTm / 100
        const timeLastCheckIn = usageDetailStay.lastCheckInTm / 100
        this.checkinTimeOptions = this.checkinTimeOptions.filter(
          (item) =>
            parseInt(item.value) >= timeCheckIn && parseInt(item.value) <= timeLastCheckIn
        )
      }
    },
    async fetchSubsidySettingBasicList() {
      let subsidySettingBasicList = null
      if (this.subsidyList && this.subsidyList.length > 0) {
        subsidySettingBasicList = await this.$repositories('coupon')
          .getSubsidySettingBasicList({
            filterBy: 'subsidy_id',
            filterOp: 'in',
            filterValue: this.subsidyList.map(s => s.availableData.subsidyId).join('|'),
          })
          .catch((error) => {
            return error
          })
      }
      // 01:企業負担（預り金精算） 02:企業負担（実費請求） 05:その他
      if (subsidySettingBasicList.setting != null && subsidySettingBasicList.setting.some(s => ["01", "02", "05"].includes(s.payOffForm))) {
        this.showRelationName = true
      }
      else {
        this.showRelationName = false
      }
    },
    onBlur() {
      const age = _.get(this.inputFormData, 'age', '')
      if (age < 1) {
        this.inputFormData.age = null
      } else if (age[0] === '0' || age[0] === '０') {
        this.inputFormData.age = age[1]
      }
    },
    selectUseCoupon() {
      this.$store.dispatch(IS_USE_COUPON, this.useCoupon)
    },
    getBenepoPoint() {
      this.$store.dispatch(GET_BENEPO_POINT).then((data) => {
        if (data) {
          this.totalPoint = _.get(data, 'totalPoint', 0)
        }
      })
    },
    selectUseBenepoPoint() {
      this.$store.dispatch(IS_USE_BENEPO_POINT, this.useBenepoPoint)
    },
    updateStayRoomData() {
      this.stayRoomDetails = this.stayRoomDetails.map((room) => {
        room.adultCount =
          _.get(room, 'member.man', 0) +
          _.get(room, 'member.woman', 0) +
          _.get(room, 'visitors.man', 0) +
          _.get(room, 'visitors.woman', 0)

        room.childrenCount = 0
        room.childrenCount += Object.keys(room.memberChildren)
          .map((key) => room.memberChildren[key])
          .reduce((a, b) => a + b, 0)
        room.childrenCount += Object.keys(room.visitorChildren)
          .map((key) => room.visitorChildren[key])
          .reduce((a, b) => a + b, 0)
        return room
      })
    },
    handleDataSave() {
      this.updateStayRoomData()
      const data = {
        checkinTime: this.checkinTime,
        valueCheckbox1: this.valueCheckbox1,
        valueCheckbox: this.valueCheckbox,
        inputFormData: this.isShowFormInfo ? this.inputFormData : '',
        stayRoomDetails: this.stayRoomDetails,
        questionList: this.questionList,
        totalFee: this.calculateTotalAmount,
        othInfo: {
          moveDiv: this.moveDiv,
          ckinSchDatetime:
            this.customerPlan && this.customerPlan.stayDay
              ? this.customerPlan.stayDay.replaceAll('/', '-')
              : null
        },
        totalAdultPeople: this.countAdultPeople,
        totalChildren: this.totalChildren,
        menuStayParams: this.menuStayParams,
        reserveId: null,
        showRelationship: this.showRelationship,
        grantedBenepo: this.grantedBenepo,
        checkSaveRelationship: true,
        representativeInfo: this.isShowFormInfo ? this.inputFormData : '',
        deputyInfo: this.deputation,
        adultTypeData: this.adultTypeData,
        childTypeData: this.childTypeData
      }
      return data
    },
    async handleDeleteSlot() {
      // MN 宿泊在庫引当解除
      const customerPlan = this.customerPlanState
      if(customerPlan && customerPlan.menuNo && customerPlan.roomId && customerPlan.reserveId){
        const deleteDataStock = {
          menuNo: customerPlan.menuNo,
          roomId: customerPlan.roomId,
          reserveId : customerPlan.reserveId
        }
        this.$store.dispatch(DELETE_AVAILABLE_STOCK, deleteDataStock)
        this.$store.dispatch('order/setOrderId', null)

        customerPlan.reserveId = null
        await this.$store.dispatch(SAVE_CUSTOMER_PLAN, customerPlan)
      }

    },
    validateCheckInTime() {
      // validate checkinTime
      if (this.checkinTime === null) {
        this.checkInTimeErrorMsg = MESSAGE_ERROR.TIME_PICKER
        this.errors.push({ name: 'checkinTimeError', message: this.checkInTimeErrorMsg })
        return false
      }
      this.checkInTimeErrorMsg = ''
      return true
    },
    validateVehicle() {
      if (this.moveDiv === null && !this.isRakuten) {
        this.checkVehicleErrorMsg = '交通手段を選択してください'
        this.errors.push({
          name: 'checkVehicleError',
          message: this.checkVehicleErrorMsg
        })
        return false
      }
      this.checkVehicleErrorMsg = ''
      return true
    },
    validateDeputation(numRoom = null) {
      let errors = false
      if (Number.isInteger(numRoom)) {
        this.deputationErrors[numRoom].errors = {}
        if(!this.deputation[numRoom].isDeputation) {
          this.deputationErrors[numRoom].errors.error_deputation = MESSAGE_ERROR.FORM_FAMILY_DEPUTATION
          errors = true
        }
        if (!this.deputation[numRoom].familyName || !this.deputation[numRoom].firstName) {
          this.deputationErrors[numRoom].errors.error_name = MESSAGE_ERROR.FORM_FAMILY_NAME_ROMAJI
          errors = true
        }
        if (!this.deputation[numRoom].familyNameKana || !this.deputation[numRoom].firstNameKana) {
          this.deputationErrors[numRoom].errors.error_name_kana = MESSAGE_ERROR.FORM_FAMILY_NAME_HIRA
          errors = true
        }
      } else {
        this.deputation.forEach((info, idx) => {
          this.deputationErrors[idx].errors = {}
          if (!info.isDeputation) {
            this.deputationErrors[idx].errors.error_deputation = MESSAGE_ERROR.FORM_FAMILY_DEPUTATION
            errors = true
          }
          if (!info.familyName || !info.firstName) {
            this.deputationErrors[idx].errors.error_name = MESSAGE_ERROR.FORM_FAMILY_NAME_ROMAJI
            errors = true
          }
          if (!info.familyNameKana || !info.firstNameKana) {
            this.deputationErrors[idx].errors.error_name_kana = MESSAGE_ERROR.FORM_FAMILY_NAME_HIRA
            errors = true
          }
        })
      }
      if (errors) {
        return false
      }
      return true
    },
    validateRelationshipMsg() {
      if (!this.validateRelationship()) {
        this.checkRelationshipErrorMsg =
          '関係を確認するには、ボタン「人数確定」を押してください'
        this.errors.push({
          name: 'checkRelationshipError',
          message: this.checkRelationshipErrorMsg
        })
        return false
      }
      this.checkRelationshipErrorMsg = ''
      return true
    },
    validateRepresentivePeople() {
      let pass = true
      if (this.isShowFormInfo) {
        const kanaLength =
          _.get(this.inputFormData, 'familyNameKana.length') +
          _.get(this.inputFormData, 'firstNameKana.length')
        if (kanaLength) {
          this.inputFormData.familyNameKana = this.inputFormData.familyNameKana.trim()
          this.inputFormData.firstNameKana = this.inputFormData.firstNameKana.trim()
        }
        if (!this.inputFormData.familyNameKana || !this.inputFormData.firstNameKana) {
          this.inputFormData.error_message_name_kana = MESSAGE_ERROR.FORM_FAMILY_NAME_KANA
          this.errors.push({
            name: 'firstNameKanaError',
            message: this.inputFormData.error_message_name_kana
          })
          pass = false
        } else {
          this.inputFormData.error_message_name_kana = ''
        }
        const kanjiLength =
          _.get(this.inputFormData, 'familyName.length') +
          _.get(this.inputFormData, 'firstName.length')
        if (kanjiLength) {
          this.inputFormData.familyName = this.inputFormData.familyName.trim()
          this.inputFormData.firstName = this.inputFormData.firstName.trim()
        }
        if (!this.inputFormData.familyName || !this.inputFormData.firstName) {
          this.inputFormData.error_message_name = MESSAGE_ERROR.FORM_FAMILY_NAME_KANJI
          this.errors.push({
            name: 'firstNameError',
            message: this.inputFormData.error_message_name
          })
          pass = false
        } else {
          this.inputFormData.familyName = this.inputFormData.familyName.trim()
          this.inputFormData.firstName = this.inputFormData.firstName.trim()
          this.inputFormData.error_message_name = ''
        }
        if (
          this.isRakutenPLan ||
          (this.inputFormData.phoneNumber &&
          (this.inputFormData.phoneNumber.length === 10 ||
            this.inputFormData.phoneNumber.length === 11) &&
          this.inputFormData.phoneNumber[0] === '0')
        ) {
          this.inputFormData.error_message_age = ''
        } else {
          this.inputFormData.error_message_age = '有効な電話番号を入力してください'
          this.errors.push({
            name: 'ageError',
            message: this.inputFormData.error_message_age
          })
          pass = false
        }
      }
      this.isValidateBack = pass
      return pass
    },

    /**
     * 指定された部屋の設定情報で取得したカレンダー情報で、
     * 宿泊予定日程が全て満たされているかをチェックする
     *
     * @param {*} room 部屋情報の配列
     * @returns {boolean} true: 共通日程あり(全日程宿泊可能), false: 共通日程なし（宿泊不可日あり）
     */
    isDatesAvailable(room) {
      if (this.roomCountCheckDatas.length === 0) {
        return false;
      }
      // 部屋番号で指定された部屋のvacancyCalendar結果を取得
      const roomCountCheckData = _.find(this.roomCountCheckDatas, {'roomNo':room.roomNo});
      if (!roomCountCheckData) {
        return false;
      }
      // vaccancyCalenderErrorがtrueの場合は、APIでの取得に失敗しているため、falseを返す
      if (roomCountCheckData.vacancyCalenderError) {
        return false;
      }
      // vacancycalenderから日付のみ取得
      const vacancyValidDates = roomCountCheckData.vacancyCalendar.vacancyCalendars.map(item => item.stayDay);
      for (let dateObj of room.stayDays) {
        if (!vacancyValidDates.includes(dateObj.stayDay)) {
          return false;
        }
      }
      return true;
    },
    validateRoom() {
      let memberAdults = 0
      let visitorAdults = 0
      let memberChildrenCnt = 0
      let visitorChildrenCnt = 0
      let pass = true
      const roomErrors = []
      // Check at least 1 member
      let memberCnt = 0
      this.stayRoomDetails.forEach((room) => {
        memberCnt += room.member.man + room.member.woman
      })
      this.stayRoomDetails.forEach((room, index) => {
        memberAdults +=
          (room.member && room.member.man ? +room.member.man : 0) +
          (room.member && room.member.woman ? +room.member.woman : 0)
        visitorAdults +=
          (room.visitors && room.visitors.man ? +room.visitors.man : 0) +
          (room.visitors && room.visitors.woman ? +room.visitors.woman : 0)
        this.totalAdult = memberAdults + visitorAdults
        memberChildrenCnt +=
          room.memberChildren.childrenType10 +
          room.memberChildren.childrenType15 +
          room.memberChildren.childrenType20 +
          room.memberChildren.childrenType30 +
          room.memberChildren.childrenType40 +
          room.memberChildren.childrenType50
        visitorChildrenCnt +=
          room.visitorChildren.childrenType10 +
          room.visitorChildren.childrenType15 +
          room.visitorChildren.childrenType20 +
          room.visitorChildren.childrenType30 +
          room.visitorChildren.childrenType40 +
          room.visitorChildren.childrenType50
        const eachRoomErrors = []
        const slotCount = this.countRoomSlots(room)
        
        if (slotCount < +this.minStayCapacity || room.adultCount < 1) {
          pass = false
          eachRoomErrors.push(
            `一部屋ごとの最低利用人数を満たしておりません。大人1名以上を含む${this.minStayCapacity}名以上で設定してください。`
          )
        } else if(slotCount > +this.maxStayCapacity) {
          pass = false
          eachRoomErrors.push(`一部屋ごとの最大利用人数を超過しています。大人1名以上を含み${this.maxStayCapacity}名以下で設定してください。`)
        }
        if (!memberCnt) {
          pass = false
          eachRoomErrors.push(`一つのお申込みにつき「会員（大人）」が1名以上必要です。「会員」を設定してください。`)
        }
        roomErrors.push({
          errors: eachRoomErrors
        })
      })
      this.roomErrors = roomErrors

      // その他人数プラン
      const bothRoomError = []

      // 合計人数が19名を超えないこと
      if (memberAdults + visitorAdults + memberChildrenCnt + visitorChildrenCnt > 19) {
        bothRoomError.push('1度の申込で予約可能な最大人数は19名となります。')
      }

      this.bothRoomError = bothRoomError
      if (bothRoomError.length) {
        pass = false
      }

      if (!pass) {
        this.enableConfirmButton = false
      } else {
        this.enableConfirmButton = true
      }
      this.isValidateBack = pass
      return pass
    },
    getMessageErrorAge(message) {
      this.error_message_age_relationship = message
    },
    getMessageErrorSei(message) {
      this.error_message_sei_relationship = message
    },
    getMessageErrorMei(message) {
      this.error_message_mei_relationship = message
    },
    checkValidate() {
      let hasError = false
      if (!this.validateCheckInTime()) {
        hasError = true
      }

      if (!this.validateVehicle()) {
        hasError = true
      }

      // validate deputation
      if (this.isRakutenPLan && (!this.validateDeputation() || this.validateContentDeputation())) {
        hasError = true
      }

      // valudate form representive people
      if (!this.validateRepresentivePeople()) {
        hasError = true
      }
      // validate room
      if (!this.validateRoom()) {
        hasError = true
        return hasError
      }

      if (this.subsidyList && this.subsidyList.length) {
        if (!this.validateRelationshipMsg()) {
          hasError = true
        }
      }
      if (!this.validateQuestionList()) {
        hasError = true
      }
      return hasError
    },
    validateContentDeputation() {
      const fieldContent = _.cloneDeep(this.deputation)
      if(!fieldContent.length) return false
      let isSame = false;
      for (let i = 0; i < fieldContent.length; i++) {
        for (let j = 0; j < fieldContent.length; j++) {
          if (i !== j) {
            if ((fieldContent[i].firstNameKana === fieldContent[j].firstNameKana
              && fieldContent[i].familyNameKana === fieldContent[j].familyNameKana)
              || (fieldContent[i].firstName === fieldContent[j].firstName
              && fieldContent[i].familyName === fieldContent[j].familyName)) {
                isSame = true;
                break;
            }
          }
        }
        if (isSame) {
          break;
        }
      }
      if(isSame) {
        this.errorSameValue = MESSAGE_ERROR.FIELD_SAME_VALUE
        this.errors.push({
          name: 'errorSameValue',
          message: this.errorSameValue
        })
        return true
      }
      return false
    },
    validateQuestionList() {
      this.questionList.forEach((item, index) => {
        if (item.replyIdpsbFlag === '1') {
          if (item.replyRem === '') {
            item.messageNote = true
            this.errors.push({ name: 'questionListError', message: '' })
          } else {
            delete item.messageNote
          }
        }
      })
      return !this.questionList.filter((item) => item.messageNote).length > 0
    },
    scrollToError() {
      if (this.errors && this.errors.length > 0) {
        const firstField = this.errors.map((e) => e.name)[0]
        if (firstField === 'questionListError') {
          this.$smoothScroll({
            scrollTo: this.$refs[`${firstField}`],
            offset: 0
          })
          return
        }
        this.$smoothScroll({
          scrollTo: this.$refs[`${firstField}`],
          offset: -400
        })
      }
      this.errors = []
    },
    validateRelationship() {
      if (
        !this.showRelationship &&
        !this.checkInTimeErrorMsg &&
        !this.checkVehicleErrorMsg &&
        !this.roomErrors
      ) {
        this.$toasted.error('関係を確認するには、ボタン「人数確定」を押してください')
        return false
      }

      if (this.showRelationship === false) {
        this.$toasted.error('関係を確認するには、ボタン「人数確定」を押してください')
        return false
      }
      //
      let hasInputAge = true
      let hasSelectRelationship = true
      let hasInputFirstNames = true
      let hasInputFamilyNames = true
      let allVisitorCheck = true;
      let memberAdultCount = 0;
      this.adultTypeData.forEach((adult) => {
        adult.forEach((ad) => {
          if (ad.type === 'member') {
            memberAdultCount++;
          }
        })
      })
      this.stayRoomDetails.forEach((room) => {
        const memberCnt = room.member.man + room.member.woman
        const visitorCnt = room.visitors.man + room.visitors.woman
        this.totalAdultCntMember += memberCnt

        // #76074：「次へ」ボタン押下時のhandleNext内でgetVacancyCalendar→roomAmount→onChangeRoom→applyChangeが呼ばれることがある
        // 上記の場合にstayRoomDetailsがtempStayRoomDetailsで上書きされ、続柄情報が空になりバリデーションエラーとなってしまう不具合
        // → キャッシュしておいた続柄情報があればキャッシュを使用することで回避
        if (this.cacheRelationships[room.roomNo]) {
          room.relationships = this.cacheRelationships[room.roomNo];
        }
        if (Array.isArray(room.relationships) && room.relationships.length) {
          room.relationships.forEach((item) => {
            if (item.isMember && !item.relationshipCode) {
              hasSelectRelationship = false
            }
            if ((item.age > 12 || item.age < 0 || !item.age) && item.isChildren) {
              hasInputAge = false
            }
            if (item.isChildren) {
              if (!this.validateAgeChild(item.age)) {
                hasInputAge = false
              }
            }
            if (this.showRelationName && !item.firstName) {
              hasInputFirstNames = false
            }
            if (this.showRelationName && !item.familyName) {
              hasInputFamilyNames = false
            }
          })
        } else if (this.showRelationship && !this.isRoomVisitorOnly(room)) {
          // 続柄選択を表示しているが、続柄を選択していない場合(room.relationshipsがない場合）エラー
          // ビジターのみの部屋はエラー扱いにしない
          hasSelectRelationship = false
        }
      })
      if (memberAdultCount === 0 && this.isRakutenPLan) {
        if (!(this.roomErrors[0].errors.length > 0)) {
          this.$toasted.error('会員の宿泊者が1名以上必要です。')
        }
        return false
      }
      if (!hasSelectRelationship) {
        if (!(this.roomErrors[0].errors.length > 0)) {
          this.$toasted.error('人数確定ボタンを押し、続柄を設定してください。')
        }
        return false
      }
      if (!hasInputAge) {
        this.error_message_age_relationship =
          '会員子どもの年齢は12歳以下を入力してください。'
        return false
      }
      if (!hasInputFamilyNames) {
        this.error_message_sei_relationship = MESSAGE_ERROR.FORM_SEI_KANJI_KANA_ROMAJI
        this.$toasted.error('会員の姓を入力してください。')
        return false
      }
      if (!hasInputFirstNames) {
        this.error_message_mei_relationship = MESSAGE_ERROR.FORM_MEI_KANJI_KANA_ROMAJI
        this.$toasted.error('会員の名を入力してください。')
        return false
      }
      return true
    },
    isRoomVisitorOnly(room) {
      if (room) {
        const member = room.member;
        const memberChildren = room.memberChildren;
        const visitors = room.visitors;
        const visitorChildren = room.visitorChildren;
        // メンバー会員が一人もいない
        if (member && member.man == 0 && member.woman == 0
            && memberChildren
            && memberChildren.childrenType10 == 0
            && memberChildren.childrenType15 == 0
            && memberChildren.childrenType20 == 0
            && memberChildren.childrenType30 == 0
            && memberChildren.childrenType40 == 0
            && memberChildren.childrenType50 == 0
        ) {
          // ビジター会員が一人以上いる
          if (visitors && (visitors.man > 0 || visitors.woman > 0)
              || (visitorChildren
                && (visitorChildren.childrenType10 > 0
                || visitorChildren.childrenType15 > 0
                || visitorChildren.childrenType20 > 0
                || visitorChildren.childrenType30 > 0
                || visitorChildren.childrenType40 > 0
                || visitorChildren.childrenType50 > 0)
              )
          ) {
            return true;
          }
        }
      }
      return false;
    },
    selectVehicle(value) {
      this.moveDiv = value
    },
    async handleNext() {
      await this.mutex.lock();
      try {
        if(this.isNextClickEnabled){
          this.isNextClickEnabled = false;
          this.checkZipcodeForm = true
          this.isValidateNative = true
          this.updateStayDays()
          if (! await this.getVacancyCalendar()) {
            this.$toasted.error(
              'ご指定された条件ではご利用いただけません。<br>日程またはご利用人数を設定し直すか、他のプランをご利用ください。'
            ) 
            this.isNextClickEnabled = true;
            return ;
          }

          // 64187:宿泊日程などが無く申込が不可能な場合
          if(this.stayRoomDetails.some(room => !this.isDatesAvailable(room))){
            this.$toasted.error(
              'ご選択いただいた宿泊プランは売り切れました。<br>改めて検索画面から別の日程・プラン、施設をご検討ください。'
            )
            this.isNextClickEnabled = true;
            return ;
          }

          const data = this.handleDataSave()
          this.$store.dispatch(SAVE_RELATIONSHIP, this.showRelationship).then(() => {})
          if (this.checkValidate()) {
            this.scrollToError()
            this.isNextClickEnabled = true;
            return
          }
          if (this.bothRoomError.length) {
            this.$smoothScroll({
              scrollTo: this.$refs[`warningMsg`],
              offset: -400
            })
            this.isNextClickEnabled = true;
            return
          }
          if (!this.isErrorZipcode) {
            this.$smoothScroll({
              scrollTo: this.$refs[`zipcodeForm`],
              offset: 0
            })
            this.isNextClickEnabled = true;
            return
          }

          // MN 在庫引当 ※ 52931 の暫定対応
          const reserveId = await this.handleKeepSlot()
          if ( reserveId === MN_RESERVE_NOTHING && this.getReservationDiv() !== "20") {
            this.$toasted.error('選択された部屋の数が、空室な部屋の数を超えました。');
            this.isNextClickEnabled = true;
            return ;
          }
          let isStayRequest = false;
          if (reserveId === MN_RESERVE_NOTHING && this.getReservationDiv() === "20") {
            isStayRequest = true;
          }

          // 申込情報をキャッシュ
          const orderId = await this.cacheOrder(data)
          if(orderId){
            this.$store.dispatch('order/setOrderId', orderId)
          }
          else {
            this.$toasted.error('エラーが発生しました');
            this.isNextClickEnabled = true;
            return;
          }

          /// UPDATE DATA PLAN DETAILS
          let memberAdults = 0
          let visitorAdults = 0
          const memberChldDetails = {}
          const visitorChldDetails = {}
          data.stayRoomDetails.forEach((room) => {
            memberAdults += room.member.man + room.member.woman
            visitorAdults += room.visitors.man + room.visitors.woman
            Object.keys(room.memberChildren).forEach((key) => {
              if (memberChldDetails[key]) {
                memberChldDetails[key] += room.memberChildren[key]
              } else {
                memberChldDetails[key] = room.memberChildren[key]
              }
            })
            Object.keys(room.visitorChildren).forEach((key) => {
              if (visitorChldDetails[key]) {
                visitorChldDetails[key] += room.visitorChildren[key]
              } else {
                visitorChldDetails[key] = room.visitorChildren[key]
              }
            })
          })
          const customerPlan = _.cloneDeep(this.customerPlan)
          customerPlan.memberAdults = memberAdults
          customerPlan.visitorAdults = visitorAdults
          customerPlan.memberChldDetails = memberChldDetails
          customerPlan.visitorChldDetails = visitorChldDetails
          if(this.vacancyCalendar) {
            customerPlan.vacancyCalendar = this.vacancyCalendar;
          }
          customerPlan.reserveId = reserveId
          this.$store.dispatch(SAVE_CUSTOMER_PLAN, customerPlan)
          const totalAdult = +memberAdults + visitorAdults

          // 宿泊料金が0円の場合
          if(this.calculateTotalAmount <= 0) {
            this.$toasted.error("ご予約が中断されました。再度、はじめからお申込みください");
            this.isNextClickEnabled = true;
            return;
          }

          // 申込入力確定
          if (totalAdult > 0) {
            // 申込確認画面に遷移
            data.reserveId = _.get(customerPlan, 'reserveId', null)
            data.isStayRequest = isStayRequest;
            this.$store.dispatch(SAVE_DATA_BS_APP_02_001, data).then(
              () => {
                this.$store.getters.customerPlan.toPlanDetailFrom = false
                const query = this.$route.query
                this.$router.push({ path: '/register-confirmation', query })
              },
              (error) => {
                this.$toasted.error(error)
              }
            )
          } else {
            this.$smoothScroll({
              scrollTo: this.$refs['checkAdultMinError'],
              offset: -200
            })
          }
        }
      } finally {
        this.mutex.unlock();
      }
    },
    async handleBack() {
      // ---------------data
      const customerPlan = _.cloneDeep(this.customerPlan)
      this.isValidateNative = true
      this.updateStayDays()
      const { menuNo, planId, roomId } = this.$route.query
      const backQuery = _.cloneDeep(this.$route.query)
      delete backQuery.menuNo
      delete backQuery.planId
      delete backQuery.roomId

      if (await this.getVacancyCalendar()) {
        const data = this.handleDataSave()
        /// UPDATE DATA PLAN DETAILS
        let memberAdults = 0
        let visitorAdults = 0
        const memberChldDetails = {}
        const visitorChldDetails = {}
        data.stayRoomDetails.forEach((room) => {
          memberAdults += room.member.man + room.member.woman
          visitorAdults += room.visitors.man + room.visitors.woman
          Object.keys(room.memberChildren).forEach((key) => {
            if (memberChldDetails[key]) {
              memberChldDetails[key] += room.memberChildren[key]
            } else {
              memberChldDetails[key] = room.memberChildren[key]
            }
          })
          Object.keys(room.visitorChildren).forEach((key) => {
            // if (visitorChldDetails[key]) {
            //   visitorChldDetails[key] += room.visitorChildren[key]
            // } else {
            //   visitorChldDetails[key] = room.visitorChildren[key]
            // }

            if (memberChldDetails[key]) {
              memberChldDetails[key] += room.visitorChildren[key]
            } else {
              memberChldDetails[key] = room.visitorChildren[key]
            }
          })
        })

        Object.keys(memberChldDetails).forEach((key) => {
          memberChldDetails[key] = Math.floor(
            memberChldDetails[key] / customerPlan.stayRooms
          )
        })

        customerPlan.memberAdults = Math.floor(
          (memberAdults + visitorAdults) / customerPlan.stayRooms
        )
        customerPlan.visitorAdults = visitorAdults
        customerPlan.memberChldDetails = memberChldDetails
        customerPlan.visitorChldDetails = visitorChldDetails
        this.$store.dispatch(SAVE_CUSTOMER_PLAN, customerPlan)
        // const totalAdult = +memberAdults + visitorAdults

        if (this.showRelationship) {
          let hasSelectRelationship = true
          this.stayRoomDetails.forEach((room) => {
            if (!room.relationships || !room.relationships.length) {
              hasSelectRelationship = false
            }
          })
          if (
            !hasSelectRelationship &&
            !this.checkInTimeErrorMsg &&
            !this.checkVehicleErrorMsg
          ) {
            this.isValidateBack = false
          }
        } else if (!this.showRelationship) {
          if (
            !this.checkInTimeErrorMsg &&
            !this.checkVehicleErrorMsg &&
            !this.roomErrors
          ) {
            this.isValidateBack = false
          }
        }

        // const query = this.$route.query
        // if (this.checkinTime && this.isValidateBack) {
        this.$store.dispatch(SAVE_DATA_BS_APP_02_001, data).then(
          () => {
            this.$router.push({
              path: `/menus/${menuNo}/plans/${planId}/rooms/${roomId}`,
              query: backQuery
            })
          },
          (error) => {
            this.$toasted.error(error)
          }
        )
      } else {
        this.$router.push({
          path: `/menus/${menuNo}/plans/${planId}/rooms/${roomId}`,
          query: backQuery
        })
      }
      // }
    },
    trimSpace() {
      this.inputFormData.familyName =
        this.inputFormData && this.inputFormData.familyName
          ? this.inputFormData.familyName.trim()
          : ''
      this.inputFormData.firstName =
        this.inputFormData && this.inputFormData.firstName
          ? this.inputFormData.firstName.trim()
          : ''
      this.inputFormData.familyNameKana =
        this.inputFormData && this.inputFormData.familyNameKana
          ? this.inputFormData.familyNameKana.trim()
          : ''
      this.inputFormData.firstNameKana =
        this.inputFormData && this.inputFormData.firstNameKana
          ? this.inputFormData.firstNameKana.trim()
          : ''
    },
    goto(path = null) {
      if (path) {
        if (path === '/') {
          this.$router.push({ path, query: {} })
          return
        }
        if (path === 'plan') {
          const query = {}
          const { menuNo, planId, roomId } = this.$route.query
          this.$router.push({
            path: `/menus/${menuNo}/plans/${planId}/rooms/${roomId}`,
            query
          })
        }
      }
    },
    async getGrantedBenepoStay() {
      let returnBenepo = 0
      const { menuNo, planId, roomId } = this.$route.query
      const benepoReturnInfo = this.getPlanInfo?.benepoReturnInfo;
       if (this.stayRoomDetails && Array.isArray(this.stayRoomDetails)) {
          let childrenType10 = 0
          let childrenType15 = 0
          let childrenType20 = 0
          let childrenType30 = 0
          let childrenType40 = 0
          let childrenType50 = 0
          let adultHeadCnt = 0

          for( let item of this.stayRoomDetails){
            adultHeadCnt += item.adultCount
            childrenType10 +=  item.memberChildren?.childrenType10,
            childrenType15 += item.memberChildren?.childrenType15,
            childrenType20 += item.memberChildren?.childrenType20,
            childrenType30 += item.memberChildren?.childrenType30,
            childrenType40 += item.memberChildren?.childrenType40,
            childrenType50 += item.memberChildren?.childrenType50
          }
          const params = {
              adultHeadCnt: adultHeadCnt,
              exUpperGradesHeadCnt: childrenType10,
              exLowerGradesHeadCnt: childrenType15,
              youjiAHeadCnt: childrenType20,
              youjiBHeadCnt: childrenType30,
              youjiCHeadCnt: childrenType40,
              youjiDHeadCnt: childrenType50
          }

          const benepoReturnDiv = this.totalPeopleCnt == 1 ? benepoReturnInfo?.benepoReturnDiv1:
          this.totalPeopleCnt > 1 ? benepoReturnInfo?.benepoReturnDiv2 : null;
          const benepoReturnRate = this.totalPeopleCnt == 1 ? benepoReturnInfo?.benepoReturnRate1:
          this.totalPeopleCnt > 1 ? benepoReturnInfo?.benepoReturnRate2 : 0;
          const benepoReturnFixed = this.totalPeopleCnt == 1 ? benepoReturnInfo?.benepoReturnFixed1:
          this.totalPeopleCnt > 1 ? benepoReturnInfo?.benepoReturnFixed2 : 0;
          if(benepoReturnDiv==='10'){
            let response= await this.$repositories('plan').getGrantedBenepoStay({ menuNo, planId, billingAmount :this.calculateTotalAmount, params  });
            returnBenepo = response.grantedBenepo;
          } else if(benepoReturnDiv==='20') returnBenepo = benepoReturnFixed;
      }
      return returnBenepo;
    },
    async getRakutenInformation() {
      // 楽天の場合、施設からの連絡事項を楽天APIから取得する必要がある為追加：2022/12/24
      const rakutenHotelNo = _.get(this.getPlanInfo, 'menuInformation.extSystemMenuId');

      await this.$repositories('menu').getRakutenInformation(rakutenHotelNo)
      .then(
        (response) => {
          this.rakutenPolicyInfo.note = response.hotelPolicyInfo?.note;
          this.rakutenOtherInfo.otherInformation = response.hotelOtherInfo?.otherInformation;
        }
      )
      .catch((error) => {
        console.error('getRakutenInformation', error);
      })
    },
    async handleKeepSlot() { //  ※ 52931 の暫定対応
      // 在庫引当 呼び出し
      const customerPlan = _.cloneDeep(this.customerPlan)
      const detailDays = this.customerPlan ? this.customerPlan.detailDays : []
      const stayDay =  moment(detailDays[0].stayDay)

      const lengthOfDetaildays = Array.isArray(detailDays) ? detailDays.length : 1

      const checkInDay = stayDay.format('YYYY/MM/DD')
      const checkOutDay = stayDay.add(lengthOfDetaildays, 'days').format('YYYY/MM/DD')

      // MN 宿泊在庫引当
      const dataStock = {
        checkInDay,
        checkOutDay,
        menuNo: customerPlan.menuNo,
        roomId: customerPlan.roomId,
        roomCnt: Number(customerPlan.stayRooms),
      }
      this.$loading.show()
      return await this.$store.dispatch(SAVE_AVAILABLE_STOCK, dataStock).then(
        (res) => {
          const reserveId = res.reserveId
          this.$loading.hide();
          return reserveId;
        },
        (error) => {
          this.$toasted.error('サーバーのエラー')
          this.$loading.hide();
          return MN_RESERVE_NOTHING;
        }
      )
    },
    getReservationDiv() {
      const vacancyCalendars =
        this.vacancyCalendar && Array.isArray(this.vacancyCalendar) && Array.isArray(this.vacancyCalendar[0].vacancyCalendars)
          ? this.vacancyCalendar[0].vacancyCalendars
          : []
      if (vacancyCalendars && vacancyCalendars[0]) {
        return vacancyCalendars[0].reservationDiv;
      }
      return null;
    },
    /**
     * 申込情報をRedisにキャッシュし、orderIdを取得する。
     *
     * @param {*} data bs_app_02_001
     * @returns {*} orderId
     */
    async cacheOrder(data) {
      const { menuNo, planId, roomId } = this.$route.query
      const checkInDay = moment(this.customerPlan.stayDay).format('YYYY/MM/DD')
      const stayNights = this.customerPlan.stayNights
      const checkOutDay = moment(checkInDay).add(stayNights, 'days').format('YYYY/MM/DD')
      const stayDays = []
      for(let night = 0; night < stayNights; night++){
        stayDays.push(moment(checkInDay).add(night, 'days').format('YYYY/MM/DD'))
      }
      const stayDetails = []
      data.stayRoomDetails.forEach(room => {
        stayDetails.push({
          roomNo: room.roomNo,
          adultHeadCnt: room.adultCount,
          member: room.member,
          visitors: room.visitors,
          memberChildren: room.memberChildren,
          visitorChildren: room.visitorChildren,
          exUpperGradesHeadCnt: parseInt(room.memberChildren?.childrenType10 || 0) + parseInt(room.visitorChildren?.childrenType10 || 0),
          exLowerGradesHeadCnt: parseInt(room.memberChildren?.childrenType15 || 0) + parseInt(room.visitorChildren?.childrenType15 || 0),
          youjiAHeadCnt: parseInt(room.memberChildren?.childrenType20 || 0) + parseInt(room.visitorChildren?.childrenType20 || 0),
          youjiBHeadCnt: parseInt(room.memberChildren?.childrenType30 || 0) + parseInt(room.visitorChildren?.childrenType30 || 0),
          youjiCHeadCnt: parseInt(room.memberChildren?.childrenType40 || 0) + parseInt(room.visitorChildren?.childrenType40 || 0),
          youjiDHeadCnt: parseInt(room.memberChildren?.childrenType50 || 0) + parseInt(room.visitorChildren?.childrenType50 || 0),
        })
      })

      const orderParam = {
        menuNo: menuNo,
        planId: planId,
        roomId: roomId,
        stayNights: stayNights,
        stayDays: stayDays,
        payMthdDiv: this.CONST_DATA.STAY_PAYEE_DIV.ADVANCE, // 本API実施時点では事前決済想定
        checkInDay: checkInDay,
        checkOutDay: checkOutDay,
        stayDetails: stayDetails
      }

      return this.$repositories('order').orderInput(orderParam).then(
        (data) => {
          return data.orderId
        },
        (error) => {
          return null
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';

.label {
  line-height: 1.4;
  white-space: wrap;
}

.content {
  &__label {
    position: relative;
    &::after {
      content: "必須";
      position: absolute;
      top: 5%;
      right: 10%;
      padding: 0.25rem;
      --tw-text-opacity: 1;
      color: rgba(218, 41, 28, var(--tw-text-opacity));
      font-size: 10px;
      font-weight: normal;
      width: 30px;
      height: 25px;
      border: 1px solid #da291c;
      border-radius: 3px;
    }
    &--tel {
      &::after {
        right: 30%;
      }
    }
  }
}

.custom-divider {
  background-color: #CACCCF;
}
.rel-note {
  @apply text-xs;
  color: #73767A;
  @screen lg {
    font-size: 0.625rem;
  }
}

::v-deep .title-box {
  h2 {
     @screen lg {
        font-size: 18px;
     }
  }
}

@media (max-width: $contentWidthS) {
  .content {
    &__label {
      &::after {
        right: 30%;
      }
      &--tel {
        &::after {
          right: 46%;
        }
    }
    }
  }
}
</style>
